import * as React from "react";
import {ChangeEvent} from "react";
import LengthIntervalField, {LengthUnit} from "../../../metamodel/Fields/LengthIntervalField";
import * as FormGroup from "react-bootstrap/lib/FormGroup";
import * as ControlLabel from "react-bootstrap/lib/ControlLabel";
import * as FormControl from "react-bootstrap/lib/FormControl";
import * as InputGroup from "react-bootstrap/lib/InputGroup";
import {UnitValue} from "../../types";

export interface LengthInterval {
    min?: number,
    max?: number
}

// tslint:disable-next-line:interface-name
export interface LengthIntervalFilterFieldProps {
    field: LengthIntervalField,
    value?: LengthInterval,
    onChange?: (value: LengthInterval) => void
}

const units: LengthUnit[] = ["mm", "cm", "m", "km"];

interface InternalLengthInterval {
    min?: UnitValue,
    max?: UnitValue
}

interface LengthIntervalFilterFieldState {
    value?: InternalLengthInterval
}

export class LengthIntervalFilterField extends React.Component<LengthIntervalFilterFieldProps, LengthIntervalFilterFieldState> {
    constructor(props: LengthIntervalFilterFieldProps) {
        super(props);
        this.state = {
            value : props.value ? {
                min: props.value.min ? new UnitValue(props.value.min, 'mm') : undefined,
                max: props.value.max ? new UnitValue(props.value.max, 'mm') : undefined
            } : undefined
        };
        this.onMinUnitChange = this.onMinUnitChange.bind(this);
        this.onMinValueChange = this.onMinValueChange.bind(this);
        this.onMaxValueChange = this.onMaxValueChange.bind(this);
        this.onMaxUnitChange = this.onMaxUnitChange.bind(this);
    }

    public render(): React.ReactNode {
        return <FormGroup className="range-filter" key={`filter-${this.props.field.id}`}>
                <ControlLabel>{this.props.field.name}</ControlLabel>
                <br/>
                <span>Min</span>
                <InputGroup>
                    <FormControl type="number" step="1" min={0}
                                 value={(this.state.value && this.state.value.min && this.state.value.min.value) || ''}
                                 onChange={this.onMinValueChange}/>
                    <select id={`filter-${this.props.field.id}`} value={(this.state.value && this.state.value.min && this.state.value.min.unit) || this.props.field.minLengthUnit}
                            onChange={this.onMinUnitChange}>
                        {this.getApplicableUnits().map(o => <option key={o}>{o}</option>)}
                    </select>
                </InputGroup>
                <span>Max</span>
                <InputGroup>
                    <FormControl type="number" step="1" min={0} value={(this.state.value && this.state.value.max && this.state.value.max.value) || ''}
                                 onChange={this.onMaxValueChange}/>
                    <select id={`filter-${this.props.field.id}`}
                            value={(this.state.value && this.state.value.max && this.state.value.max.unit) || this.props.field.maxLengthUnit} onChange={this.onMaxUnitChange}>
                        {this.getApplicableUnits().map(o => <option key={o}>{o}</option>)}
                    </select>
                </InputGroup>
            </FormGroup>
    }

    private getApplicableUnits() {
        const options: string[] = [];
        let take = false;
        for (const unit of units) {
            if (unit === this.props.field.minLengthUnit) {
                take = true;
            }
            if (take) {
                options.push(unit);
            }
            if (unit === this.props.field.maxLengthUnit) {
                take = false;
            }
        }
        return options;
    }

    private stateToProps() {
        const min = this.state.value && this.state.value.min && this.state.value.min.getRawValue() || undefined;
        const max = this.state.value && this.state.value.max && this.state.value.max.getRawValue() || undefined;
        if (min && max && min > max) {
            return undefined;
        }
        return {
            min,
            max
        }
    }

    private onMinValueChange(e: any) {
        const val = e.currentTarget.value;
        this.setState((prevState: LengthIntervalFilterFieldState) => {
           return {
               ...prevState,
               value: {
                   min: new UnitValue(
                       parseInt(val, 10),
                       (this.state.value && this.state.value.min && this.state.value.min.unit) || this.props.field.minLengthUnit
                   ),
                   max: (this.state.value && this.state.value.max) || undefined
               }
           }
        }, () => this.props.onChange && this.stateToProps() && this.props.onChange(this.stateToProps()!));
    }

    private onMaxValueChange(e: any) {
        const val = e.currentTarget.value;
        this.setState((prevState: LengthIntervalFilterFieldState) => {
            return {
                ...prevState,
                value: {
                    min: (this.state.value && this.state.value.min) || undefined,
                    max: new UnitValue(
                        parseInt(val, 10),
                        (this.state.value && this.state.value.max && this.state.value.max.unit) || this.props.field.maxLengthUnit
                    ),
                }
            }
        }, () => this.props.onChange && this.stateToProps() && this.props.onChange(this.stateToProps()!));
    }


    private onMinUnitChange(e: ChangeEvent<HTMLSelectElement>) {
        const val = e.currentTarget.value;
        this.setState((prevState: LengthIntervalFilterFieldState) => {
            return {
                ...prevState,
                value: {
                    min: new UnitValue(
                        (this.state.value && this.state.value.min && this.state.value.min.value) || undefined,
                         val as LengthUnit
                    ),
                    max: (this.state.value && this.state.value.max) || undefined
                }
            }
        }, () => this.props.onChange && this.stateToProps() && this.props.onChange(this.stateToProps()!));
    }

    private onMaxUnitChange(e: ChangeEvent<HTMLSelectElement>) {
        const val = e.currentTarget.value;
        this.setState((prevState: LengthIntervalFilterFieldState) => {
            return {
                ...prevState,
                value: {
                    min: (this.state.value && this.state.value.min) || undefined,
                    max: new UnitValue(
                        (this.state.value && this.state.value.max && this.state.value.max.value) || undefined,
                        val as LengthUnit
                    )
                }
            }
        }, () => this.props.onChange && this.stateToProps() && this.props.onChange(this.stateToProps()!));
    }
}


// WEBPACK FOOTER //
// ./src/homepage/components/filters/LengthIntervalFilterField.tsx